// context/AppContext.jsx
import { createContext, useContext, useMemo, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [features, setFeatures] = useState({
    chatbot: true,
    notifications: true,
    darkMode: true,
    animations: true
  });

  const value = useMemo(() => ({
    // App state
    isLoading,
    setIsLoading,
    
    // Features
    features,
    toggleFeature: (feature) => {
      setFeatures(prev => ({
        ...prev,
        [feature]: !prev[feature]
      }));
    },
    
    // App info
    version: '1.0.0',
    environment: import.meta.env.MODE || 'development',
    
    // Utility functions
    log: (message, data) => {
      if (import.meta.env.DEV) {
        console.log(`[Quavrion] ${message}`, data || '');
      }
    }
  }), [isLoading, features]);

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};